import type { Readable } from 'svelte/store';
import { page } from '$app/stores';
import { IS_AQUEDUCT } from '$lib/site';
import { englishPath, localizedPath, type Locale } from './routes';
export type { Locale } from './routes';
export { englishPath } from './routes';
export function localeFromPath(path: string): Locale {
	return IS_AQUEDUCT && /^\/ja(?:\/|$)/.test(path) ? 'ja' : 'en';
}
// Subscribe directly so every server-rendered component reads its request's page
// store. A module-level derived store can retain another request's subscription.
export const locale: Readable<Locale> = {
	subscribe(run, invalidate) {
		return page.subscribe(
			($page) => run(localeFromPath($page.url.pathname)),
			() => invalidate?.()
		);
	}
};
export function localizeHref(language: Locale, href: string): string {
	return IS_AQUEDUCT ? localizedPath(href, language) : href;
}
export function isAuthAction(path: string): boolean {
	return (IS_AQUEDUCT ? englishPath(path) : path) === '/auth/action';
}
